const PERSON_NAME_PATTERN = /^[\p{L}]+(?:[ \-'][\p{L}]+)*$/u;

export const PERSON_NAME_ERROR =
  "May only contain letters, spaces, hyphens, and apostrophes.";

export function isValidPersonName(name) {
  const trimmed = name?.trim();
  if (!trimmed) return false;
  return PERSON_NAME_PATTERN.test(trimmed);
}

/**
 * Returns a user-facing error for a person name field, or "" when valid.
 * Optional minLength / maxLength tighten signup without changing invite/profile defaults.
 * @param {string} name
 * @param {string} [fieldLabel="Name"]
 * @param {{ minLength?: number, maxLength?: number }} [options]
 */
export function getPersonNameError(name, fieldLabel = "Name", options = {}) {
  const { minLength, maxLength } = options;
  const trimmed = name?.trim();
  if (!trimmed) return `${fieldLabel} is required`;
  if (typeof minLength === "number" && trimmed.length < minLength) {
    if (typeof maxLength === "number") {
      return `${fieldLabel} must be between ${minLength} and ${maxLength} characters.`;
    }
    return `${fieldLabel} must be at least ${minLength} characters.`;
  }
  if (typeof maxLength === "number" && trimmed.length > maxLength) {
    if (typeof minLength === "number") {
      return `${fieldLabel} must be between ${minLength} and ${maxLength} characters.`;
    }
    return `${fieldLabel} must be at most ${maxLength} characters.`;
  }
  if (!isValidPersonName(trimmed)) {
    return `${fieldLabel} ${PERSON_NAME_ERROR}`;
  }
  return "";
}
